import { Modal as MantineModal } from "@mantine/core";
import { faXmarkLarge } from "@fortawesome/pro-solid-svg-icons";
import type { CustomModalCloseButtonFactory, IProps } from "./modal-close-button.types";
import { componentWrapper } from "../../../utilities";
import { ActionIcon } from "../../action-icon";
import { Icon } from "../../icon";

const ModalCloseButton = componentWrapper<CustomModalCloseButtonFactory, IProps>("ModalCloseButton", (props, ref) => {
    return (
        <MantineModal.CloseButton
            ref={ref}
            size="lg"
            icon={
                <ActionIcon variant="subtle" size="input-xs" color="gray" data-testid="modal-close-button">
                    <Icon size="sm" icon={faXmarkLarge} />
                </ActionIcon>
            }
            {...props}
        />
    );
});

export { ModalCloseButton };
